import { useCallback, useEffect, useRef, useState } from 'react';
import { PropsInput, PropsSearchShops } from './PropsInput';
import { Scroll } from '@sharedComponents/Scroll';
import { Grid } from '@ui-kit/Grid';
import classNames from 'classnames';
import InputMask from 'react-input-mask';
import IconSearch from './search.svg';
import IconClear from './close-circle.svg';

import styles from './Input.module.scss';

export const Input = ({ className, label, fullWidth, star, reg, error, ...props }: PropsInput): JSX.Element => {
  return (
    <div className={styles.Container}>
      {label && <legend className={classNames(styles.Label, star && styles.Star)}>{label}</legend>}
      <input className={classNames(styles.Input, className, fullWidth && styles.fullWidth, error && styles.error)} {...props} {...reg} />
      {error && <p>{error}</p>}
    </div>
  );
};

export const MaskPhone = ({ reg, ...props }: PropsInput): JSX.Element => {
  return (
    <div>
      <InputMask mask="+7 (999) 999-99-99" placeholder="+7 (___) ___-__-__" {...props} {...reg}>
        {(inputProps: JSX.IntrinsicAttributes & PropsInput) => <Input {...inputProps} />}
      </InputMask>
    </div>
  );
};

export const SearchShop = ({ shops, className, activeShop, onCheck }: PropsSearchShops): JSX.Element => {
  const [list, setList] = useState(shops);
  const [value, setValue] = useState<string>('');
  const [showList, setShowList] = useState<boolean>(false);
  const WrapperRef = useRef<HTMLInputElement>(null);
  const handleShow = useCallback(() => {
    setShowList(true);
  }, []);

  const handleClearInput = () => {
    setValue('');
    setList(shops);
  };

  const handleClick = item => {
    setShowList(false);
    onCheck(item);
    setValue(item.name);
  };

  const handleAutoComplete = useCallback(e => {
    setValue(e.target.value);
    if (e.target.value.length) {
      const newList = shops.filter(item => {
        return item.name.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setList(newList);
    }
  }, []);

  // обработка закрытия ShowList
  useEffect(() => {
    if (window) {
      const closeListAddress = e => {
        if (!e.path.includes(WrapperRef.current)) {
          setShowList(false);
        }
      };
      window.addEventListener('click', closeListAddress);
      return () => window.removeEventListener('click', closeListAddress);
    }
  }, []);

  return (
    <div className={classNames(styles.WrapperSearchShop, className)} ref={WrapperRef}>
      <Input value={value} onClick={handleShow} onChange={handleAutoComplete} placeholder={'Искать адрес'} />
      <IconSearch width={18} height={18} />
      <IconClear onClick={handleClearInput} className={classNames(styles.Clear, value.length && styles.Active)} width={20} height={20} />
      {showList && (
        <div className={styles.ListShops}>
          <Scroll classNameTrack={styles.Track} maxHeight={390}>
            <Grid gap={'0'} className={styles.Content}>
              {list.map(item => (
                <div
                  onClick={() => handleClick(item)}
                  className={classNames(styles.Item, activeShop?.id === item.id && styles.Active)}
                  key={item.id}
                >
                  {item.name}
                </div>
              ))}
            </Grid>
          </Scroll>
        </div>
      )}
    </div>
  );
};
